import { render } from "./WeddingInvitationEditPage.vue?vue&type=template&id=68593a74&lang=true"
import script from "./WeddingInvitationEditPage.vue?vue&type=script&lang=js"
export * from "./WeddingInvitationEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__